// store/modules/ui.js
export default {
  namespaced: true,
  state: () => ({
    loading: false,
    alerts: []
  }),
  getters: {
    getLoading: (state) => state.loading,
    getAlerts: (state) => state.alerts
  },
  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },

    ADD_ALERT(state, alert) {
      state.alerts.push(alert);
    },

    REMOVE_ALERT(state, id) {
      state.alerts = state.alerts.filter(a => a.id !== id);
    }
  },

  actions: {
    // Habilita o spinner de carregamento na tela
    startLoading({ commit }) {
      commit('setLoading', true);
    },
    // Desabilita o spinner de carregamento da tela
    stopLoading({ commit }) {
      commit('setLoading', false);
    },
        
    // Exibe a barra de notificações com a mensagem e cor informada
    notify({ commit }, { message, color, timeout = 5000 }) {
      const id = Date.now() + Math.random();
      
      commit('ADD_ALERT', {
        id,
        message,
        color: color || 'success',
        show: true
      });

      // Remove automaticamente após o tempo definido
      setTimeout(() => {
        commit('REMOVE_ALERT', id);
      }, timeout);
    },

    // Oculta a barra de notificações
    removeAlert({ commit }, id) {
      commit('REMOVE_ALERT', id);
    }
  }
}
